export default __webpack_public_path__ + "static/media/inn-edit-supplier.90531cf5.png";